import React, { Component } from 'react';
import Select from 'react-select';
import { ReactSelectStyles } from './SelectorUtils';

export interface SelectOptions {
  label: string;
  value: string;
}

interface SelectorProps {
  placeholder: string;
  options: SelectOptions[];
  selected: SelectOptions[];
  isMulti?: boolean;
  allowCreate?: boolean;
  onSelectionChange: (option: SelectOptions[]) => void;
}

/**
 * Tag based selector which allows selecting one or multiple options.
 */
export default class Selector extends Component<SelectorProps> {
  render() {
    return (
      <Select
        className={'cursor-pointer react-tag-selector'}
        placeholder={this.props.placeholder}
        styles={ReactSelectStyles}
        isMulti={this.props.isMulti}
        options={this.props.options}
        value={this.props.selected}
        onChange={value => this.props.onSelectionChange(value as SelectOptions[])}
      />
    );
  }
}
